import React from 'react';
import CodaDocScraper from './components/CodaDocScraper/CodaDocScraper';

function App() {
  return (
    <div className="App p-4 bg-gray-50 min-h-screen">
      <CodaDocScraper />
    </div>
  );
}

export default App;